import { Button, Dropdown, Tag, notification } from "components/common"
import {
  useCallViaGrandStreamMutation,
  useLazyGetClientCellsQuery,
  useLazyGetExternalClientCellsQuery,
} from "features/shared/api"
import { useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import Tooltip from "../../../components/common/tooltip/tooltip"
import { ACTION_TYPES, PAGES } from "../../../utils/gtm/gtmEventsData"
import { useSelector } from "react-redux"
import { fireEvent } from "../../../utils/gtm/gtmEventHandler"
import SalesPlaybookDrawer from "../../leads/components/salesPlaybook"
import { configs } from "configs"

const GrandStreamCallButton = props => {
  const { t } = useTranslation()
  const userInfo = useSelector(state => state.app.user?.info)
  const { client, leadId, disabled, from, className, willTriggerSalesPlaybook = true, ...buttonProps } = props
  const salesPlayBookDrawerRef = useRef()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [getClientCellInfo, { data: clientCells, isFetching: fetchClientCell }] = useLazyGetClientCellsQuery()
  const [callViaGrandStream, { isFetching: isFetchingCall, isError, error }] = useCallViaGrandStreamMutation()
  const [getExternalClientInfo, { data: externalCells, isFetching: fetchExternalClientCell }] =
    useLazyGetExternalClientCellsQuery()

  const callAndReset = clientCell => {
    const payload = {
      clientCell: clientCell,
      source: from?.page,
      userId: userInfo?.id,
      ...(from?.page === PAGES.telesales_listing_page && { inquiryId: leadId }),
      ...(from?.page === PAGES.external_inquiry_listing ? { externalInquiryId: client?.id } : { clientId: client?.id }),
    }
    callViaGrandStream(payload)
      .unwrap()
      .then(data => {
        notification.success({ message: t("Call Initiated Successfully") })
        configs?.isSalesPlaybookEnabled && willTriggerSalesPlaybook && salesPlayBookDrawerRef.current?.openDrawer({ clientId: client?.id, triggeredBy: "callButton" })
      })
      .catch(e => {
        notification.error({ message: e?.message })
      })

    fireEvent({
      ...ACTION_TYPES.call_contact_client,
      user_input: clientCell,
      client_id: client?.id,
      ...(leadId && { lead_id: leadId }),
      ...from,
    })
  }

  const onClick = e => {
    e.domEvent.stopPropagation()
    setDropdownOpen(false)
    from?.page === PAGES.external_inquiry_listing
      ? callAndReset(externalCells?.[e.key])
      : callAndReset(clientCells?.[e.key]?.number)
  }

  const onCopy = e => {
    e.preventDefault()
  }
  const onContextMenu = e => {
    e.preventDefault()
  }

  const items = useMemo(() => {
    return (from?.page === PAGES.external_inquiry_listing ? externalCells : clientCells)?.map((e, index) => {
      if (from?.page === PAGES.external_inquiry_listing) return { label: e, key: index, value: e }
      else {
        return {
          label: (
            <div className="d-flex flexYcenter" style={{ gap: "6px" }}>
              {e.number}
              <Tooltip title={e.lastUsedDateTime}>
                <Tag pill style={{ color: "#0091ba", "--tag-bg": "#E6F5F9" }}>
                  {e.lastUsed}
                </Tag>
              </Tooltip>
            </div>
          ),
          key: index,
          value: e?.number,
        }
      }
    })
  }, [clientCells, externalCells])

  return (
    <>
      <Dropdown
        overlayClassName="ddPhone"
        menu={{ items, onClick, onCopy, onContextMenu }}
        dropdownRender={menu => (items?.length ? <div className="dropdown-content">{menu}</div> : <></>)}
        placement="bottomLeft"
        suffixIcon=""
        disabled={disabled}
        open={dropdownOpen}
        onOpenChange={setDropdownOpen}
        destroyPopupOnHide
      >
        <Button
          loading={fetchClientCell || fetchExternalClientCell}
          className={className}
          icon={"grandStreamIcon"}
          iconProps={{ size: "1.6em" }}
          onClick={e => {
            e.stopPropagation()
            from?.page === PAGES.external_inquiry_listing
              ? getExternalClientInfo({ clientId: client?.id, actionType: "tooltip", type: "maqsam" })
              : getClientCellInfo({ clientId: client?.id, actionType: "tooltip&includeLastUsed=true" }, true)
            setDropdownOpen(true)
          }}
          content={t("Call via GrandStream")}
          color="#0091BA"
          shape="round"
          type="light"
          disabled={disabled}
          {...buttonProps}
        />
      </Dropdown>
      {willTriggerSalesPlaybook && <SalesPlaybookDrawer refs={salesPlayBookDrawerRef} />}
    </>
  )
}

export default GrandStreamCallButton
